export const REDUX_KEY = 'org-admin';
export const REDUX_WHITELIST = [
  'auth',
  'forgotPassword',
  'ecosystem',
  'addMember',
  'joinAsPartner',
  'redirect',
  'networkFilters',
  'insightPosthog',
];
